<template>
  <div>
    <headline :content="$t('bill.all_bill')">
      <div class="d-block w-100">
        <div class="d-flex justify-end mb-2">
          <v-btn elevation="1" right color="info" @click="addProduct()">
            <v-icon left>mdi-plus-box-multiple</v-icon>
            {{ $t('accounting_product.add') }}
          </v-btn>
        </div>
        <v-text-field max-width="300" :placeholder="$t('bill.search_bill')" :label="$t('bill.search_bill')"
          append-icon="mdi-magnify" v-model="search" color background-color="grey lighten-4" solo flat
          dense></v-text-field>
      </div>
    </headline>
    <layout :isSuccess="true" :isFull="true">
      <template v-slot:containerZone>
        <v-row class="mx-0">
          <v-col v-if="!isLoading" cols="12" class="px-0">
            <v-data-table v-if="dataTable" :headers="dataTable.headers" :items="dataTable.products" :items-per-page="10"
              :search="search" class="shadow-lg" :no-data-text="$t('noinfo')"
              :no-results-text="$t('no_matching_records_found')">
              <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                  <v-btn text color="yellow darken-2" @click="editProduct(item.obj)"><v-icon left>mdi-pencil</v-icon>{{
                    $t('action_type.edit') }}</v-btn>
                  <v-btn text color="error" @click="dialogRemove(item.obj)"><v-icon
                      left>mdi-trash-can-outline</v-icon>{{ $t('action_type.delete') }}</v-btn>
                </div>
              </template>
              <template v-slot:item.isMeterMonth="{ item }">
                <v-icon v-if="item.isMeterMonth" :color="item.isMeterMonth ? 'success' : ''">mdi-check-circle</v-icon>
              </template>
              <template v-slot:item.name="{ item }">
                <div class="text-truncate text-start customer-name">{{ item.name }}</div>
              </template>
            </v-data-table>
          </v-col>
          <v-col v-else class="px-0">
            <v-card class="d-flex justify-center py-10">
              <v-progress-circular indeterminate size="64" color="green"></v-progress-circular>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
    <AccountingProductManageDialog v-model="isDialog" :projectId="projectId" :product="tempProduct"
      @onSaveSuccess="onSaveSuccess" @onError="isError = true" />
    <ConfirmDialog v-if="tempProduct" v-model="isRemoveDialog" :title="$t('validate.want_delete_bill')"
      :text="$t('validate.want_delete_bill_name', { name: tempProduct.name })" :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('close')" type="error" @onOk="onRemoveAccountingProduct()" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import AccountingProductManageDialog from "@/components/AccountingProductManageDialog.component";
import Layout from "../../components/Layout";
import Headline from "../../components/Headline";
import ConfirmDialog from "@/components/ConfirmDialog.component";

export default {
  data() {
    return {
      projectId: this.$route.params.projectId,
      project: null,
      isDialog: false,
      isSuccess: false,
      isError: false,
      tempProduct: null,
      dataTable: null,
      isLoading: false,
      isRemoveDialog: false,
      search: "",
    };
  },
  components: {
    AccountingProductManageDialog,
    Layout,
    Headline,
    ConfirmDialog,
  },
  computed: {
    ...mapState({
      accountingProducts: (state) =>
        state.accountingProducts.accountingProducts,
      accountingCharts: (state) => state.accountingChart.accountingCharts,
    }),
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      this.isLoading = true;
      try {
        await this.$store.dispatch(
          "accountingProducts/getAccountingProducts",
          this.projectId
        );
        this.prepareDataTable();
        this.isLoading = false;
      } catch (error) {
        this.isError = true;
        console.log(error);
        this.isLoading = false;
      }
    },
    prepareDataTable() {
      this.dataTable = null;
      this.dataTable = {
        headers: [
          {
            text: this.$t('accounting_product.type_of_list'),
            value: "type",
            align: "center",
            width: "130px",
            sortable: false,
          },
          {
            text: this.$t('accounting_product.list_name'),
            value: "name",
            align: "center",
            width: "20%",
            sortable: false,
          },
          {
            text: this.$t('meter.unit_title'),
            value: "unit",
            align: "center",
            width: "8%",
            sortable: false,
          },
          {
            text: this.$t('tax.tax_withholding'),
            value: "whtPercent",
            align: "center",
            width: "80px",
            sortable: false,
          },
          {
            text: this.$t('tax.title_vat'),
            value: "sellVatType",
            align: "center",
            width: "80px",
            sortable: false,
          },
          {
            text: this.$t('account.accounting_code_1'),
            value: "code",
            align: "center",
            width: "5%",
            sortable: false,
          },
          {
            text: this.$t('account.accounting_code_2'),
            value: "code2",
            align: "center",
            width: "5%",
            sortable: false,
          },
          {
            text: this.$t('account.accounting_code_3'),
            value: "code3",
            align: "center",
            width: "5%",
            sortable: false,
          },
          {
            text: "Dist Code",
            value: "distCode",
            align: "center",
            width: "5%",
            sortable: false,
          },
          {
            text: this.$t('accounting_product.unit_code'),
            value: "unitCode",
            align: "center",
            width: "5%",
            sortable: false,
          },
          {
            text: this.$t('payment.previous_month_accounting'),
            value: "isMeterMonth",
            align: "center",
            width: "120px",
            sortable: false,
          },
          {
            text: "",
            value: "actions",
            sortable: false,
            // width: "5%",
            align: "center",
          },
        ],
        products: this.accountingProducts.map((product) => {
          return {
            code: product.code,
            code2: product.code2,
            code3: product.code3,
            name: product.name,
            distCode: product.distCode,
            accountingChartName: this.accountingCharts?.find(
              (d) => d.objectId === product.accountingChart?.objectId
            )?.name,
            accountingChartId: this.accountingCharts?.find(
              (d) => d.objectId === product.accountingChart?.objectId
            )?.objectId,
            type:
              product.type == "facility"
                ? this.$t('project.public_facility')
                : product.type == "rental"
                  ? this.$t('rental_rate')
                  : product.type == "service"
                    ? this.$t('area.service')
                    : product.type == "deposit"
                      ? this.$t('deposit')
                      : product.type == "discount"
                        ? this.$t('discount')
                        : product.type == "penalty"
                          ? this.$t('penalty.title')
                          : "",
            sellVatType: this.labelSellVatType(product.sellVatType),
            unit: product.unit,
            unitCode: product.unitCode,
            isMeterMonth: product.isMeterMonth,
            whtPercent: this.labelWhtPercent(product.whtPercent),
            obj: product,
          };
        }),
      };
    },
    labelSellVatType(type) {
      if (type == 1) return `${this.$globalVatPercent}%`;
      else if (type == 2) return "0%";
      else if (type == 3) return this.$t('tax.tax_na');
      else return "";
    },
    labelWhtPercent(whtPercent) {
      if (whtPercent) {
        return `${whtPercent}%`
      } else {
        return this.$t('no')
      }
    },
    addProduct() {
      this.tempProduct = null;
      this.isDialog = true;
    },
    editProduct(product) {
      this.tempProduct = product;
      this.isDialog = true;
    },
    onSaveSuccess() {
      this.isSuccess = true;
      this.prepareDataTable();
    },
    dialogRemove(product) {
      this.tempProduct = product;
      this.isRemoveDialog = true
    },
    async onRemoveAccountingProduct() {
      this.isLoading = true
      try {
        await this.$store.dispatch("accountingProducts/removeAccountingProduct",
          this.tempProduct.objectId
        )
        this.prepareDataTable()
        this.isLoading = false
      } catch (error) {
        this.isError = true
        this.isLoading = false
      }
    }
  },
};
</script>

<style></style>